// extracted by mini-css-extract-plugin
export default {"splash":"splash_splash__DnyCR","lottie":"splash_lottie__5iam-","text":"splash_text__VAmoL","bar":"splash_bar__YfcK7","init":"splash_init__9cBml","hide":"splash_hide__XYViQ"};